import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";

export default function PoshLogo() {
  const { navigate } = useContext(UtilityContext);
  return (
    <div onClick={(e) => navigate("/", e)} className="clickable">
      <h1 className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-yellow-600 to-yellow-500 lg:text-4xl font-Play">POSH</h1>
    </div>
  );
}
